import { render, staticRenderFns } from "./auditgoodsList.vue?vue&type=template&id=1612e204&scoped=true&"
import script from "./auditgoodsList.vue?vue&type=script&lang=js&"
export * from "./auditgoodsList.vue?vue&type=script&lang=js&"
import style0 from "./auditgoodsList.vue?vue&type=style&index=0&id=1612e204&lang=scss&scoped=true&"
import style1 from "./auditgoodsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612e204",
  null
  
)

component.options.__file = "auditgoodsList.vue"
export default component.exports